export const UPDATE_MEMBER_ID = 'UPDATE_MEMBER_ID';

export const updateMemberIdAction = (id) => {
  localStorage.setItem('memberId', id);
  return { type: UPDATE_MEMBER_ID, payload: id };
};
